const TopBar: React.FC = () => {
  return (
    <div className="bg-primary-900  px-[10px] z-50 top-0 fixed w-full"></div>
  )
}

export default TopBar;